'use strict';

module.exports.fileIcon = require('./file-icon');



//////////////////
// WEBPACK FOOTER
// ./src/scripts/application/filters/index.js
// module id = 174
// module chunks = 0